import React from 'react';

import { withStyles } from '@mui/styles';
import moment from 'moment';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import Button from 'components/Button';
import {
  selectActiveFilters,
  selectSearchText,
} from 'components/InfiniteTableSelfStandingV3/selectors';
import Download from 'components/SvgComponents/icons/Download';
import globalMessages from 'translations/messages/global-messages';
import localStorageUser from 'utils/localStorageUser';

export const styles = theme => ({
  icon: {
    marginRight: theme.spacing(3),
  },
});

export const ExportButton = ({
  intl,
  searchTerm,
  activeFilters,
  origin,
  filename,
  onExport,
  checkedItemsProperties = {
    ids: [],
    label: '',
  },
  disabled = false,
}) => {
  const onClick = () => {
    const locale = localStorageUser.getLanguageUserFromLocalStorage();
    const filters = {};
    Object.keys(activeFilters).forEach(key => {
      filters[key] = Array.isArray(activeFilters[key])
        ? activeFilters[key].map(({ id }) => id)
        : activeFilters[key];
    });

    const { ids, label } = checkedItemsProperties;

    const selectedIds = ids?.length ? { [label]: ids } : null;
    onExport({
      filename: `${origin?.name}_${filename.toLowerCase()}_${moment().format(
        'DD-MM-YYYY-HH-MM',
      )}.xlsx`,
      activeFilters: {
        locale,
        search_term: searchTerm,
        ...filters,
        ...selectedIds,
      },
    });
  };
  return (
    <Button disabled={disabled} variant="outlined" startIcon={<Download />} onClick={onClick}>
      {intl.formatMessage(globalMessages.export)}
    </Button>
  );
};

ExportButton.propTypes = {
  intl: PropTypes.object,
  origin: PropTypes.object,
  searchTerm: PropTypes.string,
  activeFilters: PropTypes.object,
  filename: PropTypes.string.isRequired,
  onExport: PropTypes.func.isRequired,
  checkedItemsProperties: PropTypes.shape({
    ids: PropTypes.array.isRequired,
    label: PropTypes.string.isRequired,
  }),
  disabled: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  searchTerm: selectSearchText(),
  activeFilters: selectActiveFilters(),
});

const withConnect = connect(mapStateToProps, null);

export default compose(withStyles(styles), injectIntl, withConnect)(ExportButton);
